import React from 'react';

import { AppWrapper } from './components/AppWrapper';
import { Header } from './components/Header';
import { ProductBuilder } from './components/ProductBuilder';
import { ErrorBoundary } from './ErrorBoundary';

const isDev = process.env.NODE_ENV === 'development';

function App() {
  localStorage.setItem('displayAccountPopup', 'true');
  return (
    <ErrorBoundary>
      <AppWrapper>
        {isDev && <Header />}
        <ProductBuilder />
      </AppWrapper>
    </ErrorBoundary>
  );
}

export default App;
